import { render, staticRenderFns } from "./AdminAcademicCourses.html?vue&type=template&id=56e401ce&scoped=true&external"
import script from "./AdminAcademicCourses.vue?vue&type=script&lang=js"
export * from "./AdminAcademicCourses.vue?vue&type=script&lang=js"
import style0 from "./AdminAcademicCourses.scss?vue&type=style&index=0&id=56e401ce&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e401ce",
  null
  
)

export default component.exports